import type { Organization } from '../api/schemas';
import { useOrganizationsState } from './useOrganizationsState';

interface UseCurrentOrganizationResult {
    organizations: Organization[];
    currentOrganization: Organization | null;
    currentOrganizationId: string | null;
    isPending: boolean;
    isError: boolean;
    error: Error | null;
}

export function useCurrentOrganization(): UseCurrentOrganizationResult {
    const organizationsState = useOrganizationsState();

    return {
        organizations: organizationsState.organizations,
        currentOrganization: organizationsState.currentOrganization,
        currentOrganizationId: organizationsState.currentOrganizationId,
        isPending: organizationsState.isPending,
        isError: organizationsState.isError,
        error: organizationsState.error
    };
}
